import React, { Component} from 'react';
import { observer, inject } from 'mobx-react';
import ItemList from '../Form/ItemList';

@inject('inventoryPcategoryStore')
@observer
class InventoryPcategory extends Component {
  render() {
    const { inventoryPcategoryStore,children } = this.props;
    return (
      <ItemList
        store={inventoryPcategoryStore}
        columns={[
          { key: 'id', label: 'ID' },
          { key: 'name', label: 'Name' },
          { key: 'description', label: 'Description' },
          { key: 'parent_id', label: 'Parent' },
        ]}
        slug={'inventory/pcategory'}
        resource={'inventory'}
        children={children}
        allowAdd
        allowEdit
        allowDelete
      />
    );
  }
}

export default InventoryPcategory;



// WEBPACK FOOTER //
// ./src/components/Inventory/PcategoryList.js